import { useNegotiation } from '@context/negotiation.context';
import Button from '@components/atoms/button/button';
import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import useHeroPdpStyles from '@hooks/hero-pdp/use-hero-pdp-styles';
import useUser from '@hooks/user/use-user';
import styles from '../CTA-product.module.scss';

export type OfferButtonProps = {
  onClick: () => void;
  className?: string;
  openFromAuthModal?: boolean;
  shouldDisplayAsLink?: boolean;
};

const OfferButton: React.FC<OfferButtonProps> = ({ onClick, openFromAuthModal, className }) => {
  const { t } = useTranslation();
  const { isAuthenticated } = useUser();
  const { initialData, negotiation } = useNegotiation();
  const { isHeroPdpStyles } = useHeroPdpStyles();
  const isDisabled = !isAuthenticated ? false : !Boolean(initialData) || Boolean(negotiation);
  const buttonSize = isHeroPdpStyles ? 'medium' : 'large';

  useEffect(() => {
    if (initialData && openFromAuthModal) {
      onClick();
    }
  }, [initialData, openFromAuthModal]);

  return (
    <Button
      disabled={isDisabled}
      onClick={onClick}
      variant="secondary"
      size={buttonSize}
      fullWidth={true}
      data-cy="pdp_mmao_btn"
      data-vc-dd-action-name="pdp_mmao_button"
      className={clsx(
        styles.CTAButtonsBlock__button,
        styles['CTAButtonsBlock__button--MMAO'],
        isHeroPdpStyles ? 'vc-btn--large--md-up' : '',
        className,
      )}
    >
      {t('PRODUCT.DETAILS.CTA.NEGOCIATE')}
    </Button>
  );
};

export default OfferButton;
